module.exports = __webpack_public_path__ + "img/sellbot-hd.dfa26bc1.png";